import React from 'react';
import { AlertCircleIcon, FileTextIcon, ScaleIcon, BellIcon, CheckCircleIcon } from 'lucide-react';
interface AlertItemProps {
  type: string;
  title: string;
  message: string;
  date: string;
  read?: boolean;
  onClick?: () => void;
}
export function AlertItem({
  type,
  title,
  message,
  date,
  read = false,
  onClick
}: AlertItemProps) {
  const getIcon = () => {
    switch (type) {
      case 'notice':
        return <BellIcon className="w-5 h-5 text-blue-600" data-id="element-18" />;
      case 'mutation':
        return <FileTextIcon className="w-5 h-5 text-amber-600" data-id="element-19" />;
      case 'dispute':
        return <ScaleIcon className="w-5 h-5 text-[#C8102E]" data-id="element-20" />;
      case 'verification':
        return <CheckCircleIcon className="w-5 h-5 text-[#006A4E]" data-id="element-21" />;
      default:
        return <AlertCircleIcon className="w-5 h-5 text-slate-600" data-id="element-22" />;
    }
  };
  const getBgColor = () => {
    switch (type) {
      case 'notice':
        return 'bg-blue-50';
      case 'mutation':
        return 'bg-amber-50';
      case 'dispute':
        return 'bg-red-50';
      case 'verification':
        return 'bg-green-50';
      default:
        return 'bg-slate-50';
    }
  };
  return <div onClick={onClick} className={`flex gap-4 p-4 rounded-lg border ${read ? 'bg-white border-slate-100' : 'bg-slate-50 border-slate-200 border-l-4 border-l-[#006A4E]'} ${onClick ? 'cursor-pointer hover:bg-slate-100 transition-colors' : ''}`} data-id="element-23">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${getBgColor()}`} data-id="element-24">
        {getIcon()}
      </div>
      <div className="flex-1" data-id="element-25">
        <div className="flex justify-between items-start mb-1" data-id="element-26">
          <h5 className={`font-semibold ${read ? 'text-slate-700' : 'text-slate-900'}`} data-id="element-27">
            {title}
          </h5>
          <span className="text-xs text-slate-400 whitespace-nowrap ml-2" data-id="element-28">
            {date}
          </span>
        </div>
        <p className="text-sm text-slate-600" data-id="element-29">{message}</p>
      </div>
    </div>;
}